import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=5101bc74&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=5101bc74&prod&lang=scss"
import style1 from "./BookingDetails.vue?vue&type=style&index=1&id=5101bc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5101bc74",
  null
  
)

export default component.exports